import { makeStyles } from '@mui/styles';
import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import classNames from 'classnames';
import React from 'react';

import { useTranslation } from '../../../../custom-hooks/useTranslation';
import { INPUT_MAX_HEIGHT } from '../constants';

const useStyles = makeStyles({
  root: {
    marginTop: 0,
    width: 285,
  },
  input: {
    maxHeight: INPUT_MAX_HEIGHT,
    minHeight: 0,
  },
  menuItem: {
    maxHeight: INPUT_MAX_HEIGHT,
  },
  groupName: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  groupItem: {
    textIndent: 12,
  },
});

const ColumnSelect = ({ columns, value, onChange, disabled, showLabel, ...props }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const getColumnText = (column) => {
    if (column.group) {
      return column.text;
    }

    const id = column.id.split('.');
    return `${column.text} (${id[1]})`;
  };

  return columns.length ? (
    <Select
      {...props}
      className={classes.root}
      InputProps={{
        inputProps: {
          className: classes.input,
        },
      }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      label={showLabel ? translateString('Column') : null}
    >
      {columns?.map((column) => (
        <MenuItem
          key={column.id}
          value={column.value}
          className={classNames(
            classes.menuItem,
            column.group ? classes.groupName : classes.groupItem
          )}
          disabled={column.group}
        >
          {getColumnText(column)}
        </MenuItem>
      ))}
    </Select>
  ) : (
    <></>
  );
};

export default ColumnSelect;
